// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29ZJV","input":"styles_input__24cjc"};